<template>
  <div class="h-100 bg-default">
    <div class="white d-flex align-center justify-center py-8 elevation-3">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">{{ title }}</h4>
          <h5 class="secondary-font text--secondary mt-2">
            {{ subtitle }}
          </h5>
        </div>
      </v-container>
    </div>
    <v-container class="pt-5">
      <v-row justify="center">
        <v-col cols="12" sm="10">
          <div class="px-3">
            <slot name="form"></slot>
          </div>
          <v-row v-if="!noButton" justify="center" class="mt-10">
            <v-btn
              :disabled="disableButton"
              @click="$emit('on-submit')"
              color="primary"
              class="secondary-font text-capitalize font-weight-black mb-8"
              elevation="24"
              rounded
              >Finalizar Avaliação
              <v-spacer></v-spacer>
              <v-icon right>mdi-arrow-right-bold-circle-outline</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    disableButton: Boolean,
    noButton: Boolean,
    qtdePerguntas: Number,
    qtdeRespostas: Number
  }
}
</script>

<style scoped>
.FichaClinica__form {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 350px;
}
</style>
